export class QrefFltype4936Model {
  code: string;
  name: string;

  constructor() {
  }
}

